var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('spaces-list',{attrs:{"item-type":"projects","item-type-single":"project"}})}
var staticRenderFns = []

export { render, staticRenderFns }